import React from 'react';

export enum ACarouselArrowDirection {
  Right = 'Right',
  Left = 'Left',
}

export interface ACarouselArrowProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  direction?: ACarouselArrowDirection;
  disabled?: boolean;
  transparent?: boolean;
  onClick?: () => void;
  className?: string;
}